export enum AnalyticsEvents {
  SignupCompleted = 'Sign-up Completed',
  OnboardingCompleted = 'Onboarding Completed',
  SignedOut = 'Signed Out',
  NotificationClicked = 'Notification Clicked',
  ExtensionIconClicked = 'Extension Icon Clicked',
  FeatureRequestClicked = 'Feature Request Clicked',
  BeaconOpened = 'Beacon Opened',
  TemplateInserted = 'Template Inserted',
  ExtraVariantAdded = 'Extra Variant Added',
  TrialExtended = 'Trial Extended',
  TrippedFeature = 'Tripped Feature',
  LoadedAPage = 'Loaded a Page',
  ClickedGetStartedOnAgencyTab = 'Clicked Get Started on Agency Tab',
  ClickedOnPayNow = 'Clicked On Pay Now',
  IntegrationConnected = 'Integration Connected',
  IntegrationDisconnected = 'Integration Disconnected',
  IntegrationConfigured = 'Integration Configured',
  PreSendPreviewLoaded = 'Pre Send Preview Loaded',
  SpintaxCreated = 'Spintax created',
  ReportsImageDownloaded = 'Reports Image Downloaded',
  FiltersApplied = 'Filters applied',
  AiVariantGenerate = 'AI Variant Generate',
  AiVariantSaved = 'AI Variant Saved',
  AiVariantDiscard = 'AI Variant Discard',
  CheckedSequenceProgress = 'Checked Sequence Progress',
  ProspectStepBifurcation = 'Prospect Step Bifurcation',
  CheckedRepliesFromSequence = 'Checked Replies From Sequence',
  CheckedPositiveRepliesFromSequence = 'Checked Positive Replies From Sequence',
  CheckedStatusOfEmailAccounts = 'Checked Status Of Email Accounts',
  DownloadMobileAppFromProfileSection = 'Download mobile app from profile section',
  DownloadMobileAppFromUnifiedInbox = 'Download mobile app from unified inbox',
  TriedJoiningSlackCommunity = 'Tried Joining Slack Community',
  DemoAccountEntered = 'Demo Account Entered',
  DemoModuleViewed = 'Demo Module Viewed',
  DemoFeedbackSubmitted = 'Demo Feedback Submitted',
  DemoEnded = 'Demo Ended',
  InboxRadarModuleViewed = 'Inbox Radar Module Viewed',
  PlacementTestCreated = 'Placement Test Created',
  PlacementTestLaunched = 'Placement Test Launched',
  PlacementTestReportShared = 'Test Report Shared',
  PlacementTestReportCSVDownloaded = 'Test Report CSV Downloaded',
  OnboardingSkipped = 'Onboarding Skipped',
}
